if (typeof barba_integration_callbacks === 'undefined') {
    var barba_integration_callbacks = [];
}
jQuery(function ($) {

    function layout_init () {
        if ($(window).width() > 1199) {
            //Desktop

            $('header .quick_menu li.login a').on('keydown', function (event) {
                if (event.shiftKey && event.code == 'Tab') {
                    var tabindex = $('.main_menu').find('.level_1').last().find('a').first();
                    tabindex.focus();
                    return false;
                }

            });
            $('header .parent_menu').on('keydown', function (event) {
                if (event.code == 'Space' || event.code == 'Enter') {
                    if (!$(this).closest('li').hasClass('level_2') || $(this).hasClass('view_sub_menu') || $(this).hasClass('back_menu')) {
                        event.preventDefault();
                        toggle_menu($(this));
                    }
                    return false;
                }

                else if (event.shiftKey && event.code == 'Tab') {
                    if ($(this).closest('li').hasClass('level_1') && !$(this).closest('li').hasClass('open')) {
                        if ($(this).closest('li').prev().length) {
                            var tabindex = $(this).closest('li').prev().find('a').first();
                            tabindex.focus();
                        }
                        else {
                            var tabindex = $('#logo a');
                            $('header li.level_1').removeClass('open');
                            tabindex.focus();
                        }
                        return false;
                    }

                }
                else if (event.code == 'Tab') {
                    if ($(this).closest('li').hasClass('level_1') && !$(this).closest('li').hasClass('open')) {
                        if ($(this).closest('li').next().length) {
                            var tabindex = $(this).closest('li').next().find('a').first();
                            tabindex.focus();
                        }
                        else {
                            var tabindex = $('.quick_menu').find('a').first();
                            tabindex.focus();
                        }

                        return false;
                    }


                }

            });
            $('header .parent_menu').on('click', function (event) {
                if (!$(this).closest('li').hasClass('level_2') || $(this).hasClass('view_sub_menu') || $(this).hasClass('back_menu')) {
                    event.preventDefault();
                }
            });
            $('header .parent_menu').on('mousedown', function (event) {
                if (!$(this).closest('li').hasClass('level_2') || $(this).hasClass('view_sub_menu') || $(this).hasClass('back_menu')) {
                    event.preventDefault();
                    toggle_menu($(this));
                }
            });

            $('header .parent_menu').on('focus', function (event) {
                if ($(this).closest('li').hasClass('level_1')) {
                    console.log('tab');
                    $('header li.level_1').each(function (index) {
                        $(this).removeClass('open');

                    });
                }
                /*
                 if (!$(this).closest('li').hasClass('level_2') || $(this).hasClass('view_sub_menu') || $(this).hasClass('back_menu')) {
                 event.preventDefault();
                 toggle_menu($(this));
                 }

                 */
            });


        }
        else {
            //Responsive
            $('header .parent_menu').on('click', function (event) {
                if ($(this).hasClass('view_sub_menu') || $(this).hasClass('back_menu')) {
                    event.preventDefault();
                    toggle_menu($(this));
                }
            });
        }
        if ($('.header_submenu .btn_close').length) {
            $('.header_submenu .btn_close').on('mousedown focus', function (event) {
                $('header li.level_1').removeClass('open');
                $('header div.level_2').removeClass('open');
            });
        }
        $('.login a').on('focus', function () {
            $('header li.level_1').removeClass('open');
            $('header div.level_2').removeClass('open');
        })

        $('.burger_menu svg').on('click', function (event) {
            $('.main_menu').toggleClass('open');
            $('.burger_menu').toggleClass('open');
            if ($('.burger_menu.open').length) {
                $('body').addClass('position-fixed');
            }
            else {
                $('body').removeClass('position-fixed');
            }
        });

        if ($('ul.level_2').length) {
            $('ul.level_2 div').each(function (index) {

                if ($(this).hasClass('col-menu')) {
                    $(this).wrap('<li class="level_2"></li>');
                }
                else {
                    $(this).appendTo($(this).prev());
                }

            });

        }

        // Focus ouvre son sous menu, peu importe il est ou.
        /*
         $('header .header_submenu a').on('focus',function(event){
         if(!$(this).hasClass('btn_close')){
         console.log('2nd level menu focus')
         $('header li.level_1').removeClass('open');
         $('header div.level_2').removeClass('open');
         $(this).closest('.level_1').addClass('open');
         $(this).closest('.level_2').addClass('open');
         }
         })
         */


        $(document).on('click', 'form.sign_newsletter button[type=submit]', function (e) {
            var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
            var input = $('#mail_news');
            var isValid = true;
            if (input.val().trim() == '' || !pattern.test(input.val())) {
                input.closest('div').addClass('error');
                isValid = false;
                setTimeout(
                    function () {
                        input.closest('div').removeClass('error');
                    }, 1500);

            }
            if (!isValid) {
                e.preventDefault(); //prevent the default action
            }
        });


        function toggle_menu (ele) {
            if (ele.closest('div').hasClass('links_level_2')) {
                if (ele.closest('div.level_2').hasClass('open')) {
                    ele.closest('div.level_2').removeClass('open');
                    ele.closest('div.level_2').find('ul').hide();
                }
                else {
                    ele.closest('div.level_2').addClass('open');
                    ele.closest('div.level_2').find('ul').show();
                }

            }
            else {
                if (ele.closest('li').hasClass('open')) {
                    ele.closest('li').removeClass('open');
                }
                else {

                    $('header li.level_1').removeClass('open');
                    $('header div.level_2').removeClass('open');
                    ele.closest('li').toggleClass('open');

                }
            }


        }

        if ($('.menu_sidebar .have-child').length) {
            $('.menu_sidebar .have-child .submenu-opener').on('mousedown focus', function (event) {
                event.preventDefault();
                $(this).closest('li').toggleClass('open');
            });
            $('.menu_sidebar .have-child .submenu-opener').on('keydown', function (event) {
                //console.log(event.code);
                if (event.code == 'Space' || event.code == 'Enter') {
                    $(this).closest('li').toggleClass('open');
                    event.preventDefault();
                    return false;
                }
            });
            $('.menu_sidebar .have-child .sub_submenu-opener').on('mousedown focus', function (event) {
                event.preventDefault();
                $(this).closest('li').toggleClass('open');
            });
            $('.menu_sidebar .have-child .sub_submenu-opener').on('keydown', function (event) {
                //console.log(event.code);
                if (event.code == 'Space' || event.code == 'Enter') {
                    $(this).closest('li').toggleClass('open');
                    event.preventDefault();
                    return false;
                }
            });

        }
        if ($('.is-style-boxed-accordion ').length) {
            window.addEventListener('hashchange', function() {
                if (window.location.hash.length) {
                    var $anchor = jQuery(window.location.hash);
                    if ($anchor.length) {
                        if ($anchor.hasClass('is-style-boxed-accordion')) {
                            $anchor.removeClass('close').find('.is-style-accordion').slideDown();
                        } else {
                            var $parent_accordion = $anchor.parents('.is-style-boxed-accordion');
                            if ($parent_accordion.length) {
                                $parent_accordion.eq(0).removeClass('close').find('.is-style-accordion').slideDown();
                            }
                        }
                    }
                }
            });
            $('.is-style-boxed-accordion.close .wp-block-group').hide();
            $('.is-style-boxed-accordion .is_accordion').on('mousedown', function (event) {
                $(this).closest('div').toggleClass('close');
                $(this).closest('div').find('.is-style-accordion').slideToggle();
                if ($(this).find('button').attr('aria-expanded') == 'false') {
                    $(this).find('button').attr('aria-expanded', 'true')
                }
                else {
                    $(this).find('button').attr('aria-expanded', 'false')
                }

            });
            $('.is-style-boxed-accordion .is_accordion').on('keydown', function (event) {
                // Séparation pour pouvoir stopper si le keydown n'est pas tab.
                if (event.code == 'Space' || event.code == 'Enter') {
                    $(this).closest('div').toggleClass('close');
                    $(this).closest('div').find('.is-style-accordion').slideToggle();
                    if ($(this).find('button').attr('aria-expanded') == 'false') {
                        $(this).find('button').attr('aria-expanded', 'true')
                    }
                    else {
                        $(this).find('button').attr('aria-expanded', 'false')
                    }
                    return false;
                }
            });
            //Ajout de la scémentique d'accordéon
            $('.is-style-boxed-accordion ').each(function () {
                var id = $(this).find('.act-section__heading').attr('id') + '-accordion';
                var idlabel = $(this).find('.act-section__heading').attr('id') + '-label';
                $(this).find('.act-section__heading').wrapInner('<button type="button" aria-expanded="false" aria-controls="' + id + '" id="' + idlabel + '"></button>');
                $(this).find('.is-style-accordion').attr('id', id);
                $(this).find('.is-style-accordion').attr('role', 'region');
                $(this).find('.is-style-accordion').attr('aria-labelledby', idlabel);
            });
        }

        $(window).scroll(function () {
            var $window = $(window);
            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + $window.height();
            if ($(this).scrollTop() < 200) {
                $('#smoothup').removeClass('on');
            }
            else {
                $('#smoothup').addClass('on');
                if (docViewBottom - $('footer').offset().top >= 0) {
                    $('#smoothup').css({
                        'bottom': docViewBottom - $('footer').offset().top + 32 + 'px',
                        'transition': '0ms ease-in-out'
                    })

                }
                else {
                    $('#smoothup').css({
                        'bottom': '32px',
                        'transition': '250ms ease-in-out'
                    })
                }
            }
        });
        $('#smoothup').on('mousedown focus', function () {
            $('html, body').animate({ scrollTop: 0 }, 'fast');
            return false;
        });
    }

    $(document).ready(function () {
        layout_init();
        barba_integration_callbacks.push(layout_init);
        $(document).on('gform_post_render', function (event, form_id, current_page) {
            $('input[type="file"]').wrap('<label class="file_label"></label>');
            $('input[type="file"]').before('<span class="button">' + $text + '<i class="icon far fa-angle-right" aria-label="' + $text + '"> </i></span>');
            $('input[type="file"]').after('<span class="file_title"></span>');
            $('input[type=file]').on('change', function () {
                const fileName = $(this).val().split('\\').pop();
                $(this).closest('.file_label').find('.file_title').html(fileName);

            });
        });
        if ($('input[type=file]').length) {
            var $text = 'Choose a file';
            if ($('html').attr('lang') == 'fr-CA') {
                $text = 'Choisissez un fichier';
            }
            $('input[type="file"]').wrap('<label class="file_label"></label>');
            $('input[type="file"]').before('<span class="button">' + $text + '<i class="icon far fa-angle-right" aria-label="' + $text + '"> </i></span>');
            $('input[type="file"]').after('<span class="file_title"></span>');
            $('input[type=file]').on('change', function () {
                const fileName = $(this).val().split('\\').pop();
                $(this).closest('.file_label').find('.file_title').html(fileName);

            });

        }
        if ($('input.dropdown-input').length) {
            var comboplete_title = new Awesomplete('input.dropdown-input-title', {
                minChars: 0,

            });
            Awesomplete.$('.dropdown-btn-title').addEventListener('click', function () {
                if (comboplete_title.ul.childNodes.length === 0) {
                    comboplete_title.minChars = 0;
                    comboplete_title.evaluate();
                }
                else if (comboplete_title.ul.hasAttribute('hidden')) {
                    comboplete_title.open();
                }
                else {
                    comboplete_title.close();
                }
            });


            var comboplete_members = new Awesomplete('input.dropdown-input-members', {
                minChars: 0,

            });
            Awesomplete.$('.dropdown-btn-members').addEventListener('click', function () {
                if (comboplete_members.ul.childNodes.length === 0) {
                    comboplete_members.minChars = 0;
                    comboplete_members.evaluate();
                }
                else if (comboplete_members.ul.hasAttribute('hidden')) {
                    comboplete_members.open();
                }
                else {
                    comboplete_members.close();
                }
            });

            var comboplete_applicant = new Awesomplete('input.dropdown-input-applicant', {
                minChars: 0,

            });
            Awesomplete.$('.dropdown-btn-applicant').addEventListener('click', function () {
                if (comboplete_applicant.ul.childNodes.length === 0) {
                    comboplete_applicant.minChars = 0;
                    comboplete_applicant.evaluate();
                }
                else if (comboplete_applicant.ul.hasAttribute('hidden')) {
                    comboplete_applicant.open();
                }
                else {
                    comboplete_applicant.close();
                }
            });
        }

    });

    $('.act-flip-card a').on('focus', function () {
        //$(this).attr('tabindex','0');
        $('.act-flip-card').removeClass('is-active');
        $(this).closest('.act-flip-card').addClass('is-active');
    })
    $('.act-flip-card a').on('focusout', function () {
        //$(this).attr('tabindex','0');
        $(this).closest('.act-flip-card').removeClass('is-active');
    })
});
